import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Box } from '@mui/material';
import { useEffect, useMemo, useRef, useState } from 'react';

export const AbvManAccrAdjBarChart = ({ prodIds }) => {
	const rsrc = useRsrc();
	const [data, setData] = useState(null);
	const prodIdsKey = useMemo(() => JSON.stringify(prodIds ?? []), [prodIds]);
	const lastRequestKeyRef = useRef(null);

	useEffect(() => {
		if (!prodIds?.length) {
			setData({ categories: [], series: [] });
			return;
		}

		if (lastRequestKeyRef.current === prodIdsKey) {
			return;
		}

		lastRequestKeyRef.current = prodIdsKey;
		let isActive = true;

		rsrc.data('gtn', 'MAN_ACCR_ADJ_CHART_DATA_PLUGIN', { prodIds: [...prodIds] }).then((res) => {
			if (!isActive) {
				return;
			}

			// Fallback: row format per channel with 3 grouped bars.
			if (Array.isArray(res)) {
				setData({
					categories: res.map((row) => row.channelName ),
					series: [
						{
							label: 'No Entry Type',
							type: 'column',
							values: res.map((row) => Number(row.blank ?? 0)),
						},
						{
							label: 'P/L',
							type: 'column',
							values: res.map((row) => Number(row.pl ?? 0)),
						},
						{
							label: 'BS',
							type: 'column',
							values: res.map((row) => Number(row.bs ?? 0)),
						},
					],
				});
				return;
			}

			setData({ categories: [], series: [] });
		});

		return () => {
			isActive = false;
		};
	}, [prodIds, prodIdsKey, rsrc]);

	if (!data) return null;

	return (
		<Box sx={{ height: '100%' }}>
			<CartesianChart
				data={data}
				stacked={false}
				allowNegative
				dataLabels
				xLabel="Channel"
				yLabel="Amount"
			/>
		</Box>
	);
};
